import React, {useContext, useState}from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonContent, IonButton, IonImg, IonFooter, IonHeader, IonLabel, IonInput } from '@ionic/react';
import { Document, Page } from 'react-pdf';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../css/layout.css';


export function OpenInvoiceModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    const [fileLocation, setFileLocation ] = useState(null);
    
    let [viewPdf, setViewPDF] = useState(false);
    let [enterInvoiceID, setEnterInvoiceID] = useState(null);

    function closeModalHandler() {

        props.closeModal(false);
    }

    async function openPDF(){
        //window.open(props.data.fileLocation);

        const uriResult = await Filesystem.getUri({
            directory: Directory.Data,
            path: fileLocation,
          });
    
          // the path to the file
          const path = uriResult.uri;

          alert(path);
    
          // convert to capacitor//
          const localFileURL = Capacitor.convertFileSrc(path);

          alert(localFileURL);
          setFileLocation(localFileURL);

    }


    function openBroswer(){

        //alert( baseURL);
        //alert( attachement);
        //alert( baseURL+props.data.fileLocation);
        const timestamp = new Date().getTime(); // Ensures uniqueness
        const url = `${baseURL}${fileLocation}?t=${timestamp}`;
        Browser.open({ url });
        //Browser.open({ url: baseURL+attachement}).then(() => {});

    }

    function handleSetEnterInvoiceID(event)
    {
        setEnterInvoiceID(event);

        setFileLocation(`/api/form/${event}/${schema}`);
    }
    //alert('TEST - Inside View Invoice');
    //alert(props.data.fileLocation);
    //alert( baseURL+props.data.fileLocation);


    return (
    <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
                <IonGrid class='gridModalTopInfo'>
                        <IonRow>
                            <IonCol> OPEN INVOICE</IonCol>
                        </IonRow>
                </IonGrid>
            </IonHeader>
            <IonContent className='grid_content'>
                <IonGrid >
                    <IonRow>
                        <IonCol size='12'>
                            <IonLabel className="form-label" position="stacked" >Enter Invoice ID:</IonLabel>
                            <IonInput className='professional-input'
                            value={enterInvoiceID}
                            placeholder="Enter Invoice ID"
                            onIonChange={(e) => handleSetEnterInvoiceID(e.target.value)}
                            ></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                            <IonCol>
                                <IonButton onClick={openBroswer}>Open PDF</IonButton>
                            </IonCol>
                        </IonRow>
                </IonGrid >
            </IonContent>
            <IonFooter className='modal_footer_button_center'>
                <IonButton onClick={closeModalHandler}> Close </IonButton>
            </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}